import React, { useEffect, useState } from 'react'
import PageBanner from 'LuxKit/Banners/PageBanner'

export const VIRGIN_AUSTRALIA_SYSTEM_UPDATE_BANNER_END_DATE = new Date('2026-06-17T07:30:00+10:00')

export function isVirginAustraliaSystemUpdateBannerVisible(now = new Date()) {
  return now < VIRGIN_AUSTRALIA_SYSTEM_UPDATE_BANNER_END_DATE
}

function BusinessTravellerVirginAustraliaSystemUpdateBanner() {
  const [isVisible, setIsVisible] = useState(isVirginAustraliaSystemUpdateBannerVisible)

  useEffect(() => {
    if (!isVisible) {
      return
    }

    const millisecondsUntilBannerEnd = VIRGIN_AUSTRALIA_SYSTEM_UPDATE_BANNER_END_DATE.valueOf() - Date.now()

    if (millisecondsUntilBannerEnd <= 0) {
      setIsVisible(false)
      return
    }

    const timeoutId = window.setTimeout(() => setIsVisible(false), millisecondsUntilBannerEnd)

    return () => window.clearTimeout(timeoutId)
  }, [isVisible])

  if (!isVisible) {
    return null
  }

  return <PageBanner
    id="virgin-australia-system-update-banner"
    kind="warning"
    align="center"
    description={<>
      Virgin Australia will be completing a system update from 10:00pm AEST on Tuesday 16 June 2026 until 7:00am AEST on Wednesday 17 June 2026.
      <br />
      Virgin Australia flights will be unavailable to book during this time.
    </>}
  />
}

export default BusinessTravellerVirginAustraliaSystemUpdateBanner
